import React from 'react';
import './Footer.css';
import psgLogo from '../assets/psglogo.png';
import startupLogo from '../assets/startup-india.png'; // ← new import

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-left">
       
        <div className="footer-left">
  <img
    src={psgLogo}
    alt="PSG STEP Logo"
    className="footer-logo"
  />
  <img
    src={startupLogo}
    alt="Startup India Logo"
    className="footer-logo startup-logo"
  />
</div>

      </div>
      <div className="footer-center">
        <p>© {new Date().getFullYear()} Adept Knowledge Technologies. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
